import { render, staticRenderFns } from "./categories.html?vue&type=template&id=8423bf98&scoped=true&external"
import script from "./categories.js?vue&type=script&lang=js&external"
export * from "./categories.js?vue&type=script&lang=js&external"
import style0 from "./categories.scss?vue&type=style&index=0&id=8423bf98&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8423bf98",
  null
  
)

export default component.exports